import { Component, OnInit } from '@angular/core';
import { routerTransition } from "../animations"

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class SettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/settings/settings.component.ts